import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, distinctUntilChanged, finalize, tap } from 'rxjs';
import { Cmg1003Service } from '../../../cmg-1003/services/cmg-1003.service';
import { UrlaSnapshotHistoryRow } from '../../../cmg-1003/models/urla-snapshot-history-row';
import { NotificationService } from '../../../services/notification.service';
import { Button } from 'primeng/button';
import { NgClass, AsyncPipe, DecimalPipe, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { Textarea } from 'primeng/textarea';
import { CmgFormControlDomDirective } from '../../../shared/directives/cmg-form-control-dom.directive';

@Component({
  selector: 'cmg-clear2-ui-urla-save-history-modal',
  templateUrl: './urla-save-history-modal.component.html',
  styleUrls: ['./urla-save-history-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, ReactiveFormsModule, TableModule, PrimeTemplate, NgClass, Textarea, CmgFormControlDomDirective, AsyncPipe, DecimalPipe, DatePipe],
})
export class UrlaSaveHistoryModalComponent implements OnInit {
  private readonly _dialogConfig = inject(DynamicDialogConfig);
  private readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _urlaService = inject(Cmg1003Service);
  private readonly _notificationService = inject(NotificationService);

  title = 'Save History';

  closeOrCancelLabel = 'Close';

  description = '';

  descriptionMaxLength = 4000;

  showSubmitIssueFields = false;

  logs$: Observable<UrlaSnapshotHistoryRow[]>;

  formGroup = new FormGroup({
    description: new FormControl('', { validators: [Validators.required, Validators.maxLength(this.descriptionMaxLength)], nonNullable: true }),
  });

  constructor() {
    this.logs$ = this._urlaService.getUrlaSnapshotHistoryModalRows();

    if (this._dialogConfig.data?.skipToReportAnIssue) {
      this.reportAnIssue();
    }
  }

  ngOnInit() {
    this.formGroup.controls.description.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap((description) => {
          this.description = description;
        }),
      )
      .subscribe();
  }

  closeOrCancel() {
    this._dialogRef.close();
  }

  reportAnIssue() {
    this.showSubmitIssueFields = true;
    this.closeOrCancelLabel = 'Cancel';
    this.title = 'Report an Issue';
  }

  submitIssue() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    this._urlaService
      .reportAnIssueWithUrlaSave(this.description)
      .pipe(
        tap(() => {
          this._notificationService.showToastSub.next({
            severity: 'success',
            summary: '',
            detail: 'Thank you for reporting the issue. App Support will review and contact you.',
            life: 5000,
          });
        }),
        finalize(() => {
          this._dialogRef.close();
        }),
      )
      .subscribe();
  }
}
